package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.union
import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.dp

/**
 * Insets for a camera cutout the system doesn't report. A foldable's inner display can leave its
 * punch hole out of `DisplayCutout` entirely, so nothing built on `WindowInsets.displayCutout` or
 * `safeDrawing` steers clear of it; the platform host works out where it is and provides it here.
 */
val LocalHiddenCutoutInsets = staticCompositionLocalOf<WindowInsets> { WindowInsets(0.dp, 0.dp, 0.dp, 0.dp) }

/** `safeDrawing` plus [LocalHiddenCutoutInsets], for anything that must stay clear of the camera. */
@Composable
fun safeDrawingInsets(): WindowInsets = WindowInsets.safeDrawing.union(LocalHiddenCutoutInsets.current)
